import React from "react";
import ALoader from "views/pages/manage/common/a-loader";

const LoadingState = ({ isLoading = false }) => {
  if (!isLoading) return false;

  return (
    <div style={{height:"212px"}} className="d-flex justify-content-center align-items-center flex-column">
      <ALoader />
      <div className="heading-4 text-bold text-dark mt-4">
        Swipe/Insert/Tap the card
      </div>
      <div className="regular-large mt-1">
        Click confirm button to activate and receive payment
      </div>
    </div>
  );
};

export default LoadingState;
